import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";

const Scenery = () => {
  return (
    <React.Fragment>
      <SEO title="Scenery | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Scenery"
        content="For Participants"
        contentTwo="Scenery"
        linkage="/"
      />

      <EmptyTwo>
        <div className="entry-content2">
          <div className="space-50"></div>
          <h2>About Chengdu</h2>
          <br></br>
          <p className="font-black font-bold" align="justify">
            Chengdu, the capital of Sichuan Province, is an ancient yet innovative city located in southwestern China. Known as the “Land of Abundance,” Chengdu has been a center of culture, commerce, and creativity for over two thousand years. It is now one of China’s most vibrant metropolises, combining rich historical heritage with cutting-edge industries in artificial intelligence, sustainable technology, and smart urban design.
          </p>
          <p className="font-black font-bold" align="justify">
            The city’s laid-back lifestyle and inclusive spirit make it one of the most livable cities in Asia. Delegates will find a captivating mix of modern skylines, historical temples, bustling food streets, and tranquil parks. From sipping jasmine tea in a centuries-old teahouse to experiencing the innovation pulse of the Tianfu New Area, Chengdu offers a perfect balance of tradition and modernity for visitors attending ICSI’2026.
          </p>

          <br></br>

          <h3>Highlights in and around Chengdu</h3>
          <br></br>
          <ul>
            <li>
              <a href="#dufu">Du Fu Thatched Cottage</a>
            </li>
            <li>
              <a href="#dujiangyan">Dujiangyan Irrigation System</a>
            </li>
            <li>
              <a href="#qingcheng">Mount Qingcheng</a>
            </li>
            <li>
              <a href="#panda">Chengdu Research Base of Giant Panda Breeding</a>
            </li>
            <li>
              <a href="#food">Chengdu Cuisine & Local Delicacies</a>
            </li>
            <li>
              <a href="#specialties">Other Local Specialties & Souvenirs</a>
            </li>
          </ul>

          <br />
          <br />

          <h4 id="dufu">Du Fu Thatched Cottage</h4>
          <p align="justify">
            The Du Fu Thatched Cottage (杜甫草堂) is a cultural landmark dedicated to one of China’s greatest poets, Du Fu of the Tang Dynasty. Set amidst bamboo groves, lotus ponds, and winding pathways, this tranquil retreat recreates the poet’s simple thatched dwelling. Visitors can explore galleries showcasing Du Fu’s works, pavilions with calligraphy, and quiet gardens ideal for reflection. The site perfectly embodies Chengdu’s harmony between literature, nature, and art.
          </p>
          <div className="title-center">
            <p>
              <img src="./images/backgroud/scenery_dufu.jpg" alt="Du Fu Thatched Cottage" width="90%" />
            </p>
          </div>

          <br></br>
          <br></br>

          <h4 id="dujiangyan">Dujiangyan Irrigation System</h4>
          <p align="justify">
            The Dujiangyan Irrigation System (都江堰), a UNESCO World Heritage Site, is an ancient water management project built around 256 BCE. Ingeniously designed without dams, it has protected the Chengdu Plain from floods for more than two millennia while ensuring fertile soil and stable agriculture. Visitors can admire breathtaking views of the Min River, stroll across the Anlan Suspension Bridge, and visit nearby temples such as Erwang Temple, dedicated to the project’s visionary engineer Li Bing. The site represents human wisdom in living harmoniously with nature.
          </p>
          <div className="title-center">
            <p>
              <img src="./images/backgroud/scenery_dujiangyan.jpg" alt="Dujiangyan Irrigation System" width="90%" />
            </p>
          </div>

          <br></br>
          <br></br>

          <h4 id="qingcheng">Mount Qingcheng</h4>
          <p align="justify">
            Mount Qingcheng (青城山) lies just west of Chengdu and is regarded as one of the birthplaces of Taoism. Enveloped in mist and greenery, it is known for its serene temples, winding stone paths, and tranquil streams. Visitors can ascend by foot or cableway through lush forests, exploring sites such as the Shangqing Palace and Tianshi Cave. Mount Qingcheng’s poetic landscape, combined with its deep spiritual atmosphere, provides a peaceful escape from the city and a profound glimpse into traditional Chinese philosophy.
          </p>
          <div className="title-center">
            <p>
              <img src="./images/backgroud/scenery_qingcheng.jpg" alt="Mount Qingcheng" width="90%" />
            </p>
          </div>

          <br></br>
          <br></br>

          <h3>Discovering Chengdu’s Culture</h3>
          <br></br>
          <p align="justify">
            Beyond its scenic spots, Chengdu is a paradise for food lovers. The city’s cuisine is world-renowned for its “mala” (spicy and numbing) flavor. Don’t miss the authentic Sichuan hotpot, mapo tofu, and dan dan noodles. Jinli Ancient Street and Kuanzhai Alley are excellent places to enjoy local delicacies while exploring beautifully preserved Qing-era architecture and vibrant street performances. In the evenings, visitors can relax at teahouses, where locals play mahjong, listen to storytelling, or simply enjoy the leisurely rhythm of life.
          </p>

          <p align="justify">
            For those interested in traditional arts, Chengdu offers Sichuan opera shows featuring the famous face-changing performance and fire-spitting acts. The Chengdu Museum and Sichuan Museum provide in-depth insights into the region&apos;s rich history, archaeology, and folk art. Meanwhile, the Tianfu Greenway and People&apos;s Park showcase the city&apos;s commitment to sustainable living and community engagement.
          </p>

          <br></br>
          <br></br>

          <h3>Chengdu&apos;s Unique Attractions & Local Specialties</h3>
          <br></br>

          <h4 id="panda">Chengdu Research Base of Giant Panda Breeding</h4>
          <p align="justify">
            Chengdu is the adorable home of giant pandas, China&apos;s national treasure. The Chengdu Research Base of Giant Panda Breeding (成都大熊猫繁育研究基地) is one of the world&apos;s most important panda conservation centers, located just 10 kilometers from the city center. Visitors can observe these beloved animals in spacious, naturalistic habitats as they play, eat bamboo, and rest. The base is home to over 200 giant pandas and red pandas, offering an unforgettable opportunity to see these gentle creatures up close. The best viewing times are early morning (8:00-10:00 AM) when pandas are most active. Don&apos;t miss the panda cubs in the nursery area, which are particularly endearing.
          </p>
          <div className="title-center">
            <p>
              <img src="./images/backgroud/chengdu3.jpg" alt="Giant Panda Base" width="90%" />
            </p>
          </div>

          <br></br>
          <br></br>

          <h4 id="food">Chengdu Cuisine & Local Delicacies</h4>
          <p align="justify">
            Chengdu is a UNESCO City of Gastronomy, and its culinary scene is legendary. Sichuan cuisine, one of China&apos;s eight major culinary traditions, is famous for its bold flavors, particularly the &quot;mala&quot; (麻辣) combination of spicy and numbing sensations.
          </p>

          <p align="justify">
            <strong>Sichuan Hotpot (四川火锅):</strong> The quintessential Chengdu experience. Diners cook fresh ingredients—thinly sliced meats, vegetables, tofu, and more—in a bubbling pot of spicy red broth filled with dried red chili peppers and Sichuan peppercorns. Many restaurants offer split pots (鸳鸯锅) with both spicy and mild broths. Popular hotpot areas include Chunxi Road and the area around the conference venue.
          </p>

          <p align="justify">
            <strong>Mapo Tofu (麻婆豆腐):</strong> A classic Sichuan dish featuring soft tofu in a fiery, aromatic sauce made with fermented broad beans, chili oil, and ground pork. Named after a pockmarked (ma) old woman (po), this dish perfectly represents Sichuan&apos;s bold flavors.
          </p>

          <p align="justify">
            <strong>Dan Dan Noodles (担担面):</strong> A beloved street food featuring wheat noodles topped with minced pork, preserved vegetables, chili oil, and Sichuan peppercorns. The name comes from the carrying pole (dan dan) that street vendors once used to transport their noodle stalls.
          </p>

          <p align="justify">
            <strong>Kung Pao Chicken (宫保鸡丁):</strong> A world-famous dish with diced chicken, peanuts, vegetables, and dried chili peppers in a sweet and spicy sauce. The authentic Sichuan version is more complex and flavorful than international adaptations.
          </p>

          <p align="justify">
            <strong>Twice-Cooked Pork (回锅肉):</strong> A signature Sichuan dish where pork belly is first boiled, then stir-fried with leeks, fermented black beans, and chili paste, creating a rich, layered flavor.
          </p>

          <p align="justify">
            <strong>Tea Culture:</strong> Chengdu&apos;s teahouse culture is an integral part of local life. Visit People&apos;s Park (人民公园) to experience traditional teahouses where locals gather to drink tea, play mahjong, and enjoy the slow pace of life. Jasmine tea and green tea are popular choices.
          </p>

          <div className="title-center">
            <p>
              <img src="./images/backgroud/chengdu2.jpg" alt="Chengdu Hotpot" width="90%" />
            </p>
          </div>

          <br></br>
          <br></br>

          <h4 id="specialties">Other Local Specialties & Souvenirs</h4>
          <p align="justify">
            <strong>Lacquerware (漆器):</strong> Chengdu is famous for its traditional lacquerware, which has been produced for over 2,000 years. Beautiful handcrafted bowls, boxes, and decorative items make excellent souvenirs.
          </p>

          <p align="justify">
            <strong>Shu Embroidery (蜀绣):</strong> One of China&apos;s four major embroidery styles, Shu embroidery features intricate designs with vibrant colors. Silk scarves and framed artworks are popular purchases.
          </p>

          <p align="justify">
            <strong>Sichuan Pepper (花椒):</strong> The unique numbing spice that defines Sichuan cuisine. Visitors can purchase high-quality Sichuan peppercorns to bring home the authentic flavor.
          </p>

          <p align="justify">
            <strong>Panda Souvenirs:</strong> From plush toys to keychains, panda-themed merchandise is available throughout the city, especially near the panda base and tourist areas.
          </p>

          <p align="justify">
            <strong>Jinli Ancient Street & Kuanzhai Alley:</strong> These historic streets are perfect for sampling local snacks, purchasing souvenirs, and experiencing traditional architecture. Try local street foods like spicy rabbit head, skewers, and various Sichuan snacks.
          </p>

          <div className="title-center">
            <p>
              <img src="./images/backgroud/qiqi.jpg" alt="Chengdu Lacquerware" width="90%" />
            </p>
          </div>
          
          <br></br>
          <br></br>

          <h3>Travel Tips for Delegates</h3>
          <br></br>
          <p align="justify">
            Chengdu Shuangliu International Airport and Tianfu International Airport connect the city to major global destinations. The metro network is efficient and English-friendly, linking hotels, tourist areas, and conference venues. Mobile payments like Alipay and WeChat Pay are widely accepted, though many establishments also take credit cards. July in Chengdu is warm and humid (24–30°C), so light clothing, sunscreen, and an umbrella are recommended.
          </p>
          <p align="justify">
            Chengdu’s combination of cultural charm, culinary excellence, and scientific innovation will offer participants an inspiring and enjoyable experience during ICSI’2026.
          </p>
        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Scenery;
